import { Account } from '@ecm/data/Account'
import { Billing } from '@ecm/data/Billing'
import { Cart } from '@ecm/data/Cart'

export type OrderEstimateTotals = {
  total_in_cents: number
  total_discount_in_cents: number
  total_tax_in_cents: number
  subtotal_in_cents: number
}

export type OrderEstimate = {
  initial_estimate: OrderEstimateTotals

  next_estimate: OrderEstimateTotals
}
const emptyOrderEstimateTotals = () => ({
  subtotal_in_cents: 0,
  total_discount_in_cents: 0,
  total_in_cents: 0,
  total_tax_in_cents: 0,
})
export const emptyOrderEstimate = () => {
  return {
    initial_estimate: emptyOrderEstimateTotals(),
    next_estimate: emptyOrderEstimateTotals(),
  }
}

export type Order = Account & Billing & Cart
